<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template lang='pug'>
div
  div {{  location_store }}
  v-form(v-on:submit.prevent='findCoupon')
    v-text-field(label='Enter VIP ID' v-model='searchInput' clearable  @click:clear='clearSearch()' @input='clear_coupons')
    v-btn(:disabled='!searchInput || searchInput.length < 3' @click='findCoupon' outlined :loading='loading').primary--text Search
    //-   v-alert(v-if='showMap.cannotFindCustomer').error.white--text.pa-3.ma-2 <b>No Customer With {{searchIsEmail ? 'Email' : 'ID'}} {{searchInput}} Found</b>
    div(v-if='!coupons') Please Enter VIP ID
    div(v-else-if='coupons && coupons.length > 0')
        div( style='font-size:20px; font-weight:800; margin-top:20px; margin-bottom:10px;') Coupons
        div(style='font-size:15px; font-weight:800') VIP ID: {{ searchInput }}
        div(v-for='coupon in coupons' style='border:1px solid grey;').ma-2.pa-2
            //- div xx {{ coupon }}
            div <strong>Value:</strong> {{ coupon.value }}
            div <strong>Notes:</strong> {{ coupon.internal_notes }}
            div(v-if='!coupon.redemption' :style="{ color: coupon.color}") <strong>Expiration:</strong> {{ coupon.expiration }}
            div(v-else style='color:green') <strong>Redeemed:</strong> {{ coupon.redemption }}
            v-form(v-if='!coupon.redemption && coupon.color != "red"' v-on:submit.prevent='redeemCoupon(coupon.id)')
                div(style='display:flex;')
                    v-text-field(label='Enter Check #' v-model='checkNumber[coupon.id]' style='width:200px;' )
                    v-btn(:disabled='!checkNumber' @click='redeemCoupon(coupon.id)' outlined :loading='loading').primary--text Redeem
    div(v-else)
        div No Coupons Found for ID {{ searchInput }}
</template>

<script>
// import firebase from 'firebase'
import axios from 'axios'
import dayjs from 'dayjs'
// const getCoupons = firebase.functions().httpsCallable('cortezcoupons');

export default {
  name: 'FindCoupon',
  data() {
    return {
      test: 'Hello World',
      loading: false,
      searchInput: '',
      coupons: null,
      checkNumber: {},
    }
  },
  computed: {
    location_store() {
      return this.$store.getters.location
    },
  },
  methods: {
    clear_coupons() {
      this.coupons = null
      this.checkNumber = {}
    },
    async findCoupon(t, location = this.location_store) {
      this.loading = true
      // console.log('x ', t)
      console.log('Searching For ', this.searchInput)
      const result = await axios.get(`https://graphql.hartalliance.com/api/rest/j0j09fj8a73jfhasefnn790jfsdaf/${this.searchInput}`)
      // console.log('result is: ', result)
      let coupons = result.data.canvas_coupons
      // console.log('coupons i: ', coupons)
      coupons = coupons.map((c) => {
        const r = c
        r.expiration = dayjs(c.expiration).format('MM/DD/YYYY')
        r.redemption = r.redemption ? dayjs(c.redemption).format('MM/DD/YYYY h:mma') : ''
        r.color = dayjs(c.expiration) > dayjs() ? 'green' : 'red'
        if (!c.location || c.location.length < 3) {
          r.location = 'all'
        } else {
          r.location = c.location.substr(1, c.location.length - 2).split(',')
        }
        console.log('here y coupons: ', coupons, location)
        return r
      }).filter(x => (x.location.includes('all') || x.location.includes(location)))
      console.log('here x coupons: ', coupons)
      this.coupons = coupons
      this.loading = false
      return true
    },
    async redeemCoupon(t, y) {
      // console.log('t: ', t)
      // console.log('y:', y)
      this.loading = true
      const now = (new Date()).toISOString()
      // console.log('t is: ', t)
      // console.log('xt: ', `https://graphql.hartalliance.com/api/rest/j98fjasejf0fjjfasf/${t}/${this.checkNumber[t]}/${now}`)
      const result = await axios.post(`https://graphql.hartalliance.com/api/rest/j98fjasejf0fjjfasf/${t}/${this.checkNumber[t]}/${now}`)
      //   console.log('result is: ', result)
      //   this.coupons = result.data.canvas_coupons
      this.loading = false
      this.findCoupon(this.searchInput)
      return true
    },
    clearSearch() {
      console.log('Clearing Search')
      this.searchInput = ''
      this.clear_coupons()
    },
  },
};
</script>
<!-- @input='updatedSearch()' -->
